import React, { useState } from "react";
import { Layout, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import colors from "../constants/colors";
import PnsSider from "../components/PnsSider";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Route } from "react-router-dom";
import { setDrawerVisible } from "../store/actions/user";
import UserProfile from "./UserProfile";
import DashboardPage from "./DashboardPage";
import "./Admin.css";
import ModalLoading from "../components/ModalLoading";
import Projects from "./Projects";
import Plans from "./Plans.js";
import Checkout from "./Checkout";
import Callback from "./Callback";
import Billing from "./Billing";
import Users from "./Admin/Users";
import Payments from "./Admin/Payments";
import Invoices from "./Admin/Invoices";
import planActive from "./Admin/PlanActive";
const { Sider, Content, Header } = Layout;

const BillFromCallback = () => {
  return (
    <div>
      <h1>bill callback</h1>
    </div>
  );
};

export default function Admin(props) {
  const drawerVisible = useSelector((state) => state.userReducer.drawerVisible);
  const [visibleModal, setVisibleModal] = useState(true);
  const dispatch = useDispatch();
  return (
    <>
      <Layout style={{ height: "100vh" }}>
        <Sider
          breakpoint="md"
          collapsedWidth="0px"
          width={270}
          // style={{ backgroundColor: colors.googlefirstColor }}
        >
          <PnsSider />
        </Sider>
        <Layout className="main-layout">
          <Header className="HeaderMain">
            <MenuOutlined
              onClick={() => {
                dispatch(setDrawerVisible(true));
              }}
              className="drawer-icon"
            />
          </Header>
          <Content
            style={{
              backgroundColor: "#4a148c",
              padding: "10px",
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Switch>
              <Route path="/dashboard" exact component={DashboardPage} />
              <Route path="/dashboard/profile" component={UserProfile} />
              <Route path="/dashboard/projects" component={Projects} />
              <Route path="/dashboard/plans" component={Plans} />
              <Route path="/dashboard/checkout" component={Checkout} />
              <Route path="/dashboard/callback" component={Callback} />
              <Route path="/dashboard/billings" component={Billing} />
              <Route path="/dashboard/admin/users" component={Users} />
              <Route path="/dashboard/admin/payments" component={Payments} />
              <Route path="/dashboard/admin/invoices" component={Invoices} />
              <Route
                path="/dashboard/admin/bill"
                component={BillFromCallback}
              />

              <Route
                path="/dashboard/admin/planActive"
                component={planActive}
              />
            </Switch>
          </Content>
        </Layout>
      </Layout>
      <Drawer
        bodyStyle={{
          padding: 0,
          backgroundColor: colors.fifthColor,
          overflow: "auto",
        }}
        getContainer={false}
        onClose={() => {
          dispatch(setDrawerVisible(false));
        }}
        visible={drawerVisible}
      >
        <PnsSider />
      </Drawer>
      <ModalLoading
        visibleModal={visibleModal}
        setVisibleModal={setVisibleModal}
      />
    </>
  );
}
